import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import type { TopicFollowInitData } from './types';
import './style.css';

/**
 * Île React « Suivre cette rubrique » (archive éditoriale de catégorie).
 *
 * Le PHP (GasTopicFollowWidgetRenderer) rend le mount :
 *   <div id="gas-topic-follow-app" data-react-init='{...}'>fallback no-JS</div>
 *
 * Le contenu du mount sert de fallback sans JavaScript ; React le remplace.
 */
const mountEl = document.getElementById('gas-topic-follow-app');

if (mountEl?.dataset.reactInit && mountEl.isConnected) {
    let initData: TopicFollowInitData | null = null;
    try {
        initData = JSON.parse(mountEl.dataset.reactInit) as TopicFollowInitData;
    } catch (error) {
        if (window.console && window.console.error) {
            window.console.error('[gas-topic-follow] init JSON invalide', error);
        }
    }

    if (initData && initData.topic_id > 0) {
        createRoot(mountEl).render(
            <React.StrictMode>
                <App initData={initData} />
            </React.StrictMode>,
        );
    }
}
